import { apiService } from './api.js';

// Map chamber label to backend query param
export const chamberLabelToParam = (label) => (label === 'A' ? 'chamber1' : 'chamber2');

export const listO2kTransitions = async (fileId, chamberParam) => {
  const params = new URLSearchParams();
  params.append('chamber', chamberParam);
  const res = await apiService.get(`/dld8_file/${fileId}/o2kinetics/transitions_list`, { params });
  // API returns { id_dld8_file, chamber, transitions }
  return Array.isArray(res.data?.transitions) ? res.data.transitions : [];
};

export const postO2kTransition = async (fileId, chamberParam, transitionPayload) => {
  const params = new URLSearchParams();
  params.append('chamber', chamberParam);
  const res = await apiService.post(
    `/dld8_file/${fileId}/o2kinetics/transition`,
    transitionPayload,
    { params },
  );
  return res.data;
};

export const putO2kTransition = async (fileId, chamberParam, transitionPayload) => {
  const params = new URLSearchParams();
  params.append('chamber', chamberParam);
  const res = await apiService.put(
    `/dld8_file/${fileId}/o2kinetics/transition`,
    transitionPayload,
    { params },
  );
  return res.data;
};

export const deleteO2kTransition = async (fileId, chamberParam, transitionId) => {
  const params = new URLSearchParams();
  params.append('chamber', chamberParam);
  params.append('transition_id', transitionId);
  const res = await apiService.delete(`/dld8_file/${fileId}/o2kinetics/transition`, { params });
  return res.data;
};
